import { ReactElement } from "react"
import { useParams } from "react-router-dom"

import AssessDemandDeviceDisplay from "./assessDemandDeviceDisplay"
import ErrorDisplay from "../../components/fallback/errorDisplay"
import AssessDemandDeviceSkeleton from "../../components/loading/skeletons/assessDemandDeviceSkeleton"
import AppPaper from "../../components/surfaces/appPaper"
import { Datasets } from "../../constants/enums"
import { useGetFullDevice } from "../../services/middleware/hooks/deviceRegisters/useGetFullDevice"

interface IDemandUrlParams {
    deviceId: string
    dataset: Datasets
}

/** Webpage for assessment of demand devices. Dynamically picks up LCT dataset
 * and device reference from url parameters. Renders different UI components
 * based on dataset
 */
const AssessDemandDevice = (): ReactElement => {
    const { deviceId, dataset } = useParams<
        keyof IDemandUrlParams
    >() as IDemandUrlParams

    const { data, isLoading, error, isValidating, mutate } = useGetFullDevice(
        deviceId,
        dataset
    )
    if (isLoading && !data) {
        return <AssessDemandDeviceSkeleton />
    }
    if (error) {
        return (
            <AppPaper>
                <ErrorDisplay error={error} />
            </AppPaper>
        )
    }
    if (!data) {
        return (
            <AppPaper>
                <h1>No data</h1>
            </AppPaper>
        )
    }
    return (
        <AssessDemandDeviceDisplay
            data={data}
            dataset={dataset}
            isLoading={isLoading}
            isValidating={isValidating}
            mutate={mutate}
        />
    )
}

export default AssessDemandDevice
